import axios from "axios";
import { environment } from "@environments/environment";

export async function getLoginDto(accessToken: any) {
  try {
    const apiInstance = axios.create({
      baseURL: environment?.gateWayUrl,
      headers: {
        "Content-Type": "application/json",
        "product-id": "1000",
        "tenant-id": "1",
        platform: "web",
        Authorization: `Bearer ${accessToken}`,
      },
    });

    const response = await apiInstance.get(`/api/v1/user/agents/dto`);

    if (response?.data) {
      return response.data;
    } else {
      throw new Error("Failed to fetch login DTO");
    }
  } catch (error) {
    console.error("Error fetching login DTO:", error);
    throw new Error(error instanceof Error ? error.message : String(error));
  }
}

interface LoginRequest {
  phone: string ;
  password?: string;
  otp?: string;
}

interface LoginResponse {
  token?: string;
  message?: string;
  [key: string]: any;
}

export async function login(
  obj: LoginRequest,
  countryCode: string
): Promise<LoginResponse> {
  const body: any = {
    isd_code: countryCode,
    phone: obj?.phone?.toString(),
  };

  if (obj.password) {
    body.password = obj.password;
  } else {
    body.userOtp = obj.otp;
  }

  const url = `${environment.gateWayUrl}/api/v1/user/agents/login`;

  const headers = {
    "tenant-id": "1",
    "product-id": "1000",
    platform: "web",
  };

  try {
    const response = await axios.post<LoginResponse>(url, body, { headers });
    return response.data;
  } catch (error: any) {
    console.error("Login failed:", error);
    throw error.response?.data || error.message;
  }
}

